<script>
  import { mediaQueries } from '@/constants/responsive'

  export default {
    props: {
      image: {
        type: String,
        default: ''
      },
      alt: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        small: '?w=600&h=450&fit=fill',
        large: '?w=1024&h=768&fit=fill',
        mediaQueries
      }
    },
  }
</script>

<template>
  <picture>
    <source
      :media="mediaQueries.smallerThanMd"
      :srcset="`${image}${small}&fm=webp&q=80`"
      type="image/webp"
    >
    <source
      :media="mediaQueries.smallerThanMd"
      :srcset="`${image}${small}&fm=jpg&q=80`"
      type="image/jpeg"
    >
    <source
      :media="mediaQueries.largerThanMd"
      :srcset="`${image}${large}&fm=webp&q=80`"
      type="image/webp"
    >
    <source
      :media="mediaQueries.largerThanMd"
      :srcset="`${image}${large}&fm=jpg&q=80`"
      type="image/jpeg"
    >
    <img
      class="rounded"
      :src="`${image}${large}&fm=jpg&q=80`"
      :alt="alt"
    >
  </picture>
</template>
